export enum types {
  LAYOUT_DRAWER_TOGGLE = 'layout/drawer/toggle',
  LAYOUT_MENU_SHOW = 'layout/menu/show',
  LAYOUT_OPEN_CART = 'layout/open-cart',
  LAYOUT_CLOSE_RIGHT_SLIDER = 'layout/close-right-slider',
  LAYOUT_SET_PER_PAGE = 'layout/set-per-page',
}
